import { isBrowser as h } from "./ghl-ui.es1144.js";
var d = globalThis && globalThis.__awaiter || function(e, n, i, r) {
  function u(t) {
    return t instanceof i ? t : new i(function(o) {
      o(t);
    });
  }
  return new (i || (i = Promise))(function(t, o) {
    function l(c) {
      try {
        a(r.next(c));
      } catch (f) {
        o(f);
      }
    }
    function s(c) {
      try {
        a(r.throw(c));
      } catch (f) {
        o(f);
      }
    }
    function a(c) {
      c.done ? t(c.value) : u(c.value).then(l, s);
    }
    a((r = r.apply(e, n || [])).next());
  });
};
const m = (e) => e.includes("image/"), p = (e = "") => {
  const n = e.split("/"), r = n[n.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(r) || [""])[0];
}, y = /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i, F = (e) => {
  if (e.type)
    return m(e.type);
  const n = p(e.name || "");
  if (y.test(n))
    return !0;
  const i = e.thumbnailUrl || e.url || "", r = p(i);
  return !!(/^data:image\//.test(i) || y.test(r));
};
function b(e) {
  return d(this, void 0, void 0, function* () {
    return yield new Promise((n) => {
      if (!e.type || !m(e.type)) {
        n("");
        return;
      }
      n(window.URL.createObjectURL(e));
    });
  });
}
const x = h && window.FileReader && window.File;
function w(e) {
  return e.isDirectory;
}
function g(e) {
  return e.isFile;
}
function E(e, n) {
  return d(this, void 0, void 0, function* () {
    const i = [];
    function r(u) {
      return d(this, void 0, void 0, function* () {
        for (const t of u)
          if (t) {
            if (n && w(t)) {
              const o = t.createReader();
              try {
                const l = yield new Promise((s, a) => {
                  o.readEntries(s, a);
                });
                yield r(l);
              } catch {
              }
            } else if (g(t))
              try {
                const o = yield new Promise((l, s) => {
                  t.file(l, s);
                });
                i.push({
                  file: o,
                  entry: t,
                  source: "dnd"
                });
              } catch {
              }
          }
      });
    }
    return yield r(e), i;
  });
}
function L(e) {
  const {
    id: n,
    name: i,
    percentage: r,
    status: u,
    url: t,
    file: o,
    thumbnailUrl: l,
    type: s,
    fullPath: a,
    batchId: c
  } = e;
  return {
    id: n,
    name: i,
    percentage: r ?? null,
    status: u,
    url: t ?? null,
    file: o ?? null,
    thumbnailUrl: l ?? null,
    type: s ?? null,
    fullPath: a ?? null,
    batchId: c ?? null
  };
}
function _(e, n, i) {
  return e = e.toLowerCase(), n = n.toLocaleLowerCase(), i = i.toLocaleLowerCase(), i.split(",").map((u) => u.trim()).filter(Boolean).some((u) => {
    if (u.startsWith(".")) {
      if (e.endsWith(u))
        return !0;
    } else if (u.includes("/")) {
      const [t, o] = n.split("/"), [l, s] = u.split("/");
      if ((l === "*" || t && l && l === t) && (s === "*" || o && s && s === o))
        return !0;
    } else
      return !0;
    return !1;
  });
}
export {
  b as createImageDataUrl,
  L as createSettledFileInfo,
  x as environmentSupportFile,
  E as getFilesFromEntries,
  w as isFileSystemDirectoryEntry,
  g as isFileSystemFileEntry,
  F as isImageFile,
  m as isImageFileType,
  _ as matchType
};
